import React from "react";
import { FIGHTER_STATUSES } from "../lib/constants";

const COLORS = {
  actif: "border-burkina-green/60 text-burkina-green",
  fight_booked: "border-gold/60 text-gold",
  indisponible: "border-neutral-600 text-neutral-400",
  blesse: "border-burkina-red/60 text-burkina-red",
  suspendu: "border-burkina-red/60 text-burkina-red",
  inactif: "border-neutral-700 text-neutral-500",
  retraite: "border-neutral-700 text-neutral-500",
  archive: "border-neutral-800 text-neutral-600",
};

export default function StatusBadge({ status, className = "", ...rest }) {
  const label = FIGHTER_STATUSES[status] || status;
  const cls = COLORS[status] || "border-neutral-700 text-neutral-400";
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-[10px] font-stats uppercase tracking-widest border ${cls} ${className}`}
      {...rest}
    >
      <span className="w-1 h-1 rounded-full bg-current mr-2" />
      {label}
    </span>
  );
}
